import { Box, CircularProgress } from '@mui/material'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { OAUTH_CONNECTION_MESSAGE_TYPE } from '~/features/scenarios/constants'
import { TOauthConnectionMessage } from '~/features/scenarios/models'

function OauthCallback() {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const message: TOauthConnectionMessage = {
      connectionId: searchParams.get('connectionId'),
      error: searchParams.get('connectionError'),
      type: OAUTH_CONNECTION_MESSAGE_TYPE,
    }

    window.opener?.postMessage(message, window.location.origin)
    window.close()
  }, [searchParams])

  return (
    <Box
      alignItems="center"
      display="flex"
      height="100vh"
      justifyContent="center"
      width="100%"
    >
      <CircularProgress />
    </Box>
  )
}

export default OauthCallback
